import { useEffect, useState } from 'react'

import { useHasToken } from '@/hooks/useHasToken'

/** 토큰 대기 timeout — 카카오 redirect 직후 useInitAuth getAuthToken 이 응답 못 받는 케이스 안전망 */
const TOKEN_WAIT_TIMEOUT_MS = 5000

/**
 * 토큰 준비 여부 + timeout 가드.
 *  - true:  토큰 있음 (API 호출 가능)
 *  - null:  대기 중 (timeout 내, LoadingView)
 *  - false: 대기 timeout (UnknownView)
 */
export function useTokenReady(): boolean | null {
  const hasToken = useHasToken()
  const [timedOut, setTimedOut] = useState(false)

  useEffect(() => {
    if (hasToken) return
    const id = setTimeout(() => setTimedOut(true), TOKEN_WAIT_TIMEOUT_MS)
    return () => clearTimeout(id)
  }, [hasToken])

  if (hasToken) return true
  if (timedOut) return false
  return null
}
